import React from "react";
import classNames from "classnames";
import { LoadingIndicator } from "@jsq/ds/core";
import { FormSelect as Select } from "@jsq/ds/forms";
import { useGetCountryCodesQuery } from "../../../graphql/supergraph.index";
import { capitalizeEachWord } from "../../utils";
import { countrySelection } from "./styles_vanilla.css";

type Country = { code: string; name: string; id: string };
type CountryValue = keyof Country;

export type GetCountryValue = (country: Country) => Country[CountryValue];

export const defaultGetValue: GetCountryValue = (country) => country.code;

type Props = {
  name: string;
  className?: string;
  isFull?: boolean;
  placeholder?: string;
  handleChange?: (value: string | number | string[] | number[]) => void;
  getValue?: GetCountryValue;
  label?: string;
};

export const CountrySelectionDropDown: React.FunctionComponent<Props> = ({
  name,
  className = undefined,
  isFull = true,
  placeholder = "Select a country",
  handleChange = undefined,
  getValue = defaultGetValue,
  label = undefined,
}) => {
  const { loading, data } = useGetCountryCodesQuery();
  if (loading) {
    return <LoadingIndicator />;
  }
  const countryList =
    data?.countries?.edges
      ?.filter((edge) => !!edge?.node?.alpha2code)
      ?.map((edge) => {
        return { code: edge.node.alpha2code || "", name: edge.node.name, id: edge.node.id };
      })
      ?.sort((c1, c2) => (c1.name < c2.name ? -1 : 1)) || [];

  return (
    <Select
      name={name}
      full={isFull}
      placeholder={placeholder}
      className={classNames(countrySelection, className)}
      handleChange={handleChange}
      data-cy={`${name}-country`}
      data-testid={`${name}-country`}
      label={label}
    >
      <Select.Section>
        {countryList.map((country) => (
          <Select.Option key={country.id} value={getValue(country)}>
            {country.name === "U.S. Virgin Islands" // capitalizeEachWord turns U.S. Virgin Islands to U.s. Virgin Islands
              ? country.name
              : capitalizeEachWord(country.name)}
          </Select.Option>
        ))}
      </Select.Section>
    </Select>
  );
};
